<div *ngIf="!readonly" class="input-group" style="width: 220px;">
  <input [class.error]="error" [min]="min" [max]="max" class="form-control" [(ngModel)]="dateValue" [matDatepicker]="picker" (ngModelChange)="dateChange($event)"
    [placeholder]="placeholder" [name]="name" name="extension" (click)="picker.open()">
  <div class="input-group-addon" (click)="picker.open()">
    <i class="fa fa-calendar" style="cursor:pointer"></i>
  </div>
  <mat-datepicker [touchUi]="layout.state.xs" #picker></mat-datepicker>
</div>
<div class="form-control readonly" *ngIf="readonly">{{ dateValue | utcDate }}</div>